const isUniselectionMultiplicity = (multiplicity?: string): boolean =>
  !multiplicity || multiplicity === '1:1' || multiplicity === 'N:1'

export default isUniselectionMultiplicity
